import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import get from 'lodash.get';

import Spinner from 'dibs-elements/dist/Spinner';
import 'dibs-elements/dist/Spinner/buyer/Default.css';
import PhoneSVG from 'dibs-vg/dist/react/phone';
import EmailSVG from 'dibs-vg/dist/react/email';


import styles from './VipAccountManagerLink-style.scss';
import { FormattedMessage } from 'react-intl';


function VipAccountContent({userRelationships}) {
    const vipSalesRep = get(userRelationships, '[0].userDataB[0]') || {};
    const { displayName, email, phoneNumber } = vipSalesRep;

    const messageTitle = (
            <FormattedMessage
                id='dbl.Header.VipAccountManagerLink.header'
                defaultMessage="Contact your private client specialist:"
            />
    );

    const messagePhone = (
        <div className={styles.vipContent}><PhoneSVG className={styles.icon}/>{phoneNumber}</div>
    );

    const messageEmail = (
        <div className={styles.vipContent}><EmailSVG className={styles.icon}/>{email}</div>
    );
    return (
        <div className={classnames(styles.section, styles.sectionWrapper, styles.content)}>
            <div className={styles.title}>
                {messageTitle}
            </div>
            <div className={styles.copy}>
                {!userRelationships ? <Spinner dark containerClass={styles.tooltip}/> : (
                    <div>
                        <div className={styles.vipContent}>
                            {displayName}
                        </div>
                        <div className={styles.vipContent}>
                            {messagePhone}
                        </div>
                        <div className={styles.vipContent}>
                            {messageEmail}
                        </div>
                    </div>)}
            </div>
        </div>
    );
};


VipAccountContent.propTypes = {
    userRelationships: PropTypes.arrayOf(
        PropTypes.shape({
            userDataB: PropTypes.arrayOf(
                PropTypes.shape({
                    displayName: PropTypes.string,
                    phoneNumber: PropTypes.string,
                    email: PropTypes.string
                })
            )
        })
    )
};

export default VipAccountContent;



// WEBPACK FOOTER //
// ./src/components/VipAccountManagerLink/VipAccountContent.jsx